import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
export interface StoriesContentItem {
  path: string
  duration: number
}
export interface StoriesItem {
  id: number;
  name: string;
  image: string;
  videos: StoriesContentItem[];
}

export interface StoriesState {
  stories: StoriesItem[];
  currentStoryId: number | null;
  currentStory: StoriesItem | null;
  currentVideoIndex: number;
  videoDuration: number;
  videoProgress: number;
}




const initialState: StoriesState = {
  stories: [
    {
      id: 0,
      name: "Работа терминала",
      image: "/assets/img/stories2/work.png",
      videos: [
        { path: "/assets/videos/stories2/work1.png", duration: 10.00 },
        { path: "/assets/videos/stories2/work2.png", duration: 10.00 },
        { path: "/assets/videos/stories2/work3.png", duration: 10.00 },
        { path: "/assets/videos/stories2/work4.png", duration: 10.00 }
      ],
    },
    {
      id: 1,
      name: "О нас",
      image: "/assets/img/stories2/about.png",
      videos: [
        { path: "/assets/videos/stories2/about1.mp4", duration: 5.00 },
        { path: "/assets/videos/stories2/location.png", duration: 10.00 }
      ],
    },
    {
      id: 2,
      name: "Мастерская",
      image: "/assets/img/stories2/workspace.png",
      videos: [
        { path: "/assets/videos/stories2/contact1.png", duration: 10.00 },
        { path: "/assets/videos/stories2/contact2.png", duration: 10.00 },
        { path: "/assets/videos/stories2/contact3.png", duration: 10.00 },
        { path: "/assets/videos/stories2/contact4.png", duration: 10.00 }
      ],
    },
    {
      id: 3,
      name: "Отзывы",
      image: "/assets/img/stories2/review.png",
      videos: [
        { path: "/assets/videos/stories2/review1.mp4", duration: 5.00 },
        { path: "/assets/videos/stories2/review2.mp4", duration: 5.00 }
      ],
    },
    {
      id: 4,
      name: "Локации",
      image: "/assets/img/stories2/location.png",
      videos: [
        { path: "/assets/videos/stories2/location.png", duration: 10.00 }
      ],
    },
  ],
  currentStoryId: null,
  currentStory: null,
  currentVideoIndex: 0,
  videoProgress: 0,
  videoDuration: 0,
};

export const storiesState = createSlice({
  name: "StoriesState",
  initialState,
  reducers: {
    showStory: (state, action: PayloadAction<number>) => {
      state.currentStoryId = action.payload;
      state.currentStory = state.stories.find(story => story.id === action.payload) || null;
      state.videoProgress = 0; // Начинаем с нулевого прогресса
      state.currentVideoIndex = 0;
    },
    onCloseStory: (state) => {
      state.currentStoryId = null;
      state.currentStory = null;
      state.videoProgress = 0;
      state.currentVideoIndex = 0;
    },
    updateVideoProgress: (state, action: PayloadAction<VideoProgress>) => {
      state.videoProgress = action.payload.progress;
      state.videoDuration = action.payload.duration;
    },
    incrementVideoIndex: (state, action: PayloadAction<number>) => {
      if (state.currentVideoIndex != action.payload) {
        return
      }
      if (state.currentStory && state.currentStory.videos) {
        if (state.currentVideoIndex < state.currentStory.videos.length - 1) {
          state.currentVideoIndex += 1;
          state.videoProgress = 0; // Сброс прогресса для нового видео
          console.log("Есть еще видео")
        } else {
          // Если это последнее видео в истории, закрываем историю
          state.currentStoryId = null;
          state.currentStory = null;
          state.currentVideoIndex = 0;
          state.videoProgress = 0;
          console.log("Нет истории 2")
        }
      } else {
        console.log("Нет истории")

        state.currentStoryId = null;
        state.currentStory = null;
        state.currentVideoIndex = 0;
        state.videoProgress = 0;
      }
    },
    onSwipeVideo: (state, action: PayloadAction<number>) => {
      const nextStoryId = state.currentStoryId !== null ? state.currentStoryId + action.payload : 0;
      if (nextStoryId >= 0 && nextStoryId < state.stories.length) {
        state.currentStoryId = nextStoryId;
        state.currentStory = state.stories[nextStoryId] || null;
        state.videoProgress = 0;
        state.currentVideoIndex = 0;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase("CLEANUP", (state) => {
      state.currentStoryId = null;
      state.currentStory = null;
      state.videoProgress = 0;
      state.currentVideoIndex = 0;
    });
  },
});

export const { showStory, onCloseStory, updateVideoProgress, onSwipeVideo, incrementVideoIndex } = storiesState.actions;

// Selectors
export const selectCurrentStory = (state: RootState) => state.stories.currentStory;
export const selectVideoProgress = (state: RootState) => state.stories.videoProgress;
export const selectStories = (state: RootState) => state.stories.stories;
export const selectCurrentVideoIndex = (state: RootState) => state.stories.currentVideoIndex;
export const selectCurrentVideoPercent = (state: RootState) => {
  if (state.stories.videoDuration == 0) {
    return 0
  }
  return state.stories.videoProgress / state.stories.videoDuration * 100;
}
export const selectCurrentVideoDuration = (state: RootState) => {
  return state.stories.videoDuration
}
export const selectCurrentVideo = (state: RootState) => {
  const currentStory = state.stories.currentStory;
  if (currentStory && currentStory.videos) {
    return currentStory.videos[state.stories.currentVideoIndex]
  }

  return null
};
export const selectCurrentStoryIcon = (state: RootState) => {
  const currentStory = state.stories.currentStory;
  if (currentStory && currentStory.videos) {
    return currentStory.image
  }

  return null
};

export const isLastVideo = (state: RootState) => {
  const currentStory = state.stories.currentStory;
  if (currentStory && currentStory.videos) {
    return currentStory.videos.length - 1 == state.stories.currentVideoIndex
  }
  return false
}

export default storiesState.reducer;

export interface VideoProgress {
  progress: number;
  duration: number;
}